import { ListItemSecondaryAction, ListItemText, MenuItem, Switch, ListItemIcon, CircularProgress } from "@mui/material";
import { useRecordContext, useUpdate } from "react-admin";
import { type DeepPartial } from "ts-essentials";
import { EyeGlassesIcon } from "../icons/EyeGlassesIcon";
import { Student } from "../providers/studentsProvider";

export function EyeGlassesMenuItem({ closeMenu }: { closeMenu: () => void }) {
  const student = useRecordContext<Student>();
  const [update, { isLoading }] = useUpdate();

  if (!student) {
    return null;
  }

  const handleToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.checked;
    const data: DeepPartial<Student> = { needsGlasses: newValue };

    return update(
      "students",
      { id: student.id, data, previousData: student },
      {
        onSuccess: () => {
          showSuccessToast("Sehhilfe benötigt erfolgreich geändert.");
          closeMenu();
        },
        onError: (error) => {
          showErrorToast("Fehler beim Speichern der Änderungen.");
          handleError("Fehler beim Speichern.", error);
        },
      },
    );
  };

  return (
    <MenuItem>
      <ListItemIcon>
        <EyeGlassesIcon viewBox="0 0 16 16" />
      </ListItemIcon>
      <ListItemText sx={{ minWidth: "240px" }}>Sehhilfe benötigt</ListItemText>
      <ListItemSecondaryAction>
        {isLoading ? (
          <CircularProgress size={20} />
        ) : (
          <Switch
            edge="end"
            checked={!!student.needsGlasses}
            onChange={handleToggle}
            disabled={isLoading}
            inputProps={{ "aria-label": "Sehhilfe benötigt" }}
          />
        )}
      </ListItemSecondaryAction>
    </MenuItem>
  );
}
